import axios from "axios";
import { getPreferredLanguage } from "../../../helpers";
import { generateHash, generateMinifiedQuery } from "../../../Graphql/hash";
const tveProviderListQuery = `query ($device: Device!, $domain: String, $siteId: String, $country: String, $language: String) {
  bootstrap(device: $device, domain: $domain, siteId: $siteId, country: $country, language: $language) {
    appcmsPlatform {
      tveSettings {
        providers
        {
          identifier
          imageUrl
          logoUrl
          title
          fwIdentifier
          }
      }
    }
  }
}`;
const minifiedTveQuery = generateMinifiedQuery(tveProviderListQuery);
const minifiedTveQuerySHA = generateHash(minifiedTveQuery);
export function getTveProviderList() {
    var _a, _b, _c;
    let baseUrl = (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.app_data) === null || _a === void 0 ? void 0 : _a.appcmsMain) === null || _b === void 0 ? void 0 : _b.apiConfig) === null || _c === void 0 ? void 0 : _c.apiBaseCachedUrl;
    let endpoint = `${baseUrl}/graphql`;
    let variables = {
        "domain": "spinco.staging.web.viewlift.com",
        "device": "WEB",
        "country": null,
        "language": getPreferredLanguage() || 'en'
    };
    return axios.get(endpoint + '?extensions={"persistedQuery":{"version":1,"sha256Hash":' + JSON.stringify(minifiedTveQuerySHA) + '}}&variables=' + JSON.stringify(variables))
        .then(async (response) => {
        let data = response.data;
        if (data.errors) {
            if (data && data.errors && data.errors[0] && data.errors[0].message && data.errors[0].message === "PersistedQueryNotFound") {
                return await cacheTveProviderList();
            }
        }
        else {
            return data;
        }
    })
        .catch(err => console.log(`Error: ${err}`, "error"));
}
const cacheTveProviderList = () => {
    var _a, _b, _c;
    let baseUrl = (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.app_data) === null || _a === void 0 ? void 0 : _a.appcmsMain) === null || _b === void 0 ? void 0 : _b.apiConfig) === null || _c === void 0 ? void 0 : _c.apiBaseCachedUrl;
    let endpoint = `${baseUrl}/graphql`;
    let variable = {
        "domain": location.host,
        "device": "WEB",
        "country": null,
        "language": getPreferredLanguage() || 'en'
    };
    let finalPayload = {
        "query": minifiedTveQuery,
        "variables": variable,
        "extensions": {
            "persistedQuery": {
                "version": 1,
                "sha256Hash": minifiedTveQuerySHA
            }
        }
    };
    try {
        return axios.post(endpoint, finalPayload)
            .then(response => {
            return getTveProviderList();
        })
            .catch(error => {
            if (error.response) {
                console.log(error.response.data);
            }
            else {
                console.log('Error', error.message);
            }
        });
    }
    catch (err) {
        console.error("GG", err);
    }
};
